// extracted by mini-css-extract-plugin
export var avatarContainer = "_aj-0";
export var avatarTypingWave = "_aj-i";
export var gray = "_aj-f";
export var green = "_aj-c";
export var icon = "_aj-9";
export var image = "_aj-1";
export var lg = "_aj-6";
export var md = "_aj-5";
export var presenceDot = "_aj-b";
export var red = "_aj-d";
export var sm = "_aj-4";
export var status = "_aj-a";
export var typingDot = "_aj-h";
export var typingPill = "_aj-g";
export var xl = "_aj-7";
export var xs = "_aj-3";
export var xxl = "_aj-8";
export var xxs = "_aj-2";
export var yellow = "_aj-e";